import React, { useState } from 'react';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import Header from '../components/Header';
import Navbar from '../components/Navbar';
import api from '../services/api';

export default function OrchestrationPage({ setPage }) {
  const [cfg, setCfg] = useState({ simulationDays: 30, holdingCostPerUnitPerDay: 0.1 });
  const [logs, setLogs] = useState([]);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const onCh = e => setCfg({ ...cfg, [e.target.name]: +e.target.value });

  const run = async () => {
    setErr('');
    setLogs([]);
    setLoading(true);
    try {
      const { data } = await api.post('/orchestration/run', cfg);
      setLogs(data.logs || []);
    } catch (e) {
      setErr(e.response?.data?.error || 'Run failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="card-transparent p-4">
      <Header />
      <Navbar setPage={setPage} />
      <h2>Orchestration</h2>
      {err && <Alert variant="danger">{err}</Alert>}
      <Form className="mb-3">
        <Form.Control 
          name="simulationDays" 
          type="number" 
          placeholder="Days" 
          value={cfg.simulationDays} 
          onChange={onCh} 
        />
        <Form.Control 
          name="holdingCostPerUnitPerDay" 
          type="number" 
          className="mt-2" 
          placeholder="Cost/day" 
          value={cfg.holdingCostPerUnitPerDay} 
          onChange={onCh} 
        />
        <Button className="mt-2" onClick={run} disabled={loading}>
          {loading ? 'Running...' : 'Run'}
        </Button>
      </Form>
      {logs.length > 0 && (
        <pre className="p-3 bg-light rounded" style={{ maxHeight: 400, overflowY: 'auto' }}>
          {logs.join('\n')}
        </pre>
      )}
    </Container>
  );
}
